import { useCallback, useEffect, useState } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { MemberWorkloadStatusCellRenderer } from './MemberWorkloadStatusCellRenderer'
import './styles.scss'

type Props = ICellRendererParams & {
  tooltip?: (params: ICellRendererParams) => string | undefined
  hideIcon?: (params: ICellRendererParams) => boolean
  hideOpneInNewButton?: (params: ICellRendererParams) => boolean
  isExpandableRow?: (params: ICellRendererParams) => boolean
}

export const ExpandableProjectCellRenderer = (props: Props) => {
  const { node, isExpandableRow } = props
  const showExpander = isExpandableRow?.(props) ?? false
  const [expanded, setExpanded] = useState(!!node.expanded)

  useEffect(() => {
    const onExpandedChanged = () => setExpanded(!!node.expanded)
    node.addEventListener('expandedChanged', onExpandedChanged)
    return () => {
      node.removeEventListener('expandedChanged', onExpandedChanged)
    }
  }, [node])

  const handleExpandToggle = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      node.setExpanded(!node.expanded)
    },
    [node]
  )

  if (!showExpander) {
    return <MemberWorkloadStatusCellRenderer {...props} />
  }

  return (
    <div className="member_workload_status__expandable_cell">
      <span
        className={expanded ? 'ag-group-expanded' : 'ag-group-contracted'}
        onClick={handleExpandToggle}
      >
        <span
          className={`ag-icon ag-icon-tree-${expanded ? 'open' : 'closed'}`}
          role="presentation"
          unselectable="on"
        />
      </span>
      <span className="ag-group-value">
        <MemberWorkloadStatusCellRenderer {...props} />
      </span>
    </div>
  )
}
